import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as moment from 'moment';
import { forkJoin } from 'rxjs';
import { BookingListItem } from '../booking-list-item';
import { Currency } from '../currency';
import { HttpService } from '../service/http.service';
import { PaymentType } from '../payment-type';
import { SchoolInvoicePost } from '../school-invoice-post';
import { SchoolListItem } from '../school-list-item';
import { ToastMessageService } from '../toast-message.service';
import { DecimalValidator } from '../validator/decimal-validator';
import { NumberValidator } from '../validator/number-validator';
import Decimal from 'decimal.js';

@Component({
  selector: 'app-create-bulk-invoices',
  templateUrl: './create-bulk-invoices.component.html',
  styleUrls: ['./create-bulk-invoices.component.css']
})
export class CreateBulkInvoicesComponent implements OnInit {

  groupInvoiceForm!: FormGroup;
  bookings: BookingListItem[] = [];
  schools: SchoolListItem[] = [];
  invoiceForms: FormGroup[] = [];
  currencies: Currency[] = [];
  paymentTypes: PaymentType[] = [];
  uploadingInvoices = false;

  constructor(
    private httpService: HttpService,
    private builder: FormBuilder,
    private toastService: ToastMessageService
  ) { }

  ngOnInit(): void {
    forkJoin({
      schools: this.httpService.getActiveSchools(),
      currencies: this.httpService.getCurrencies(),
      paymentTypes: this.httpService.getAllPaymentTypes()
    }).subscribe(({
      schools,
      currencies,
      paymentTypes
    }) => {
      this.schools = schools;
      this.currencies = currencies;
      this.paymentTypes = paymentTypes;
      this.groupInvoiceForm = this.builder.group({
        school: null,
        currency: currencies[0],
        paymentType: paymentTypes[0],
        invoices: this.builder.array([]),
        date: new Date(),
        dueDate: null,
        invoiceNumber: null,
        comment: null,
        totalAmount: null
      });

      for(let i = 0; i < 20; i++){
        this.invoiceFormArray.push(
          this.builder.group({
            booking: [null, Validators.required],
            amount: [null, Validators.compose([DecimalValidator, NumberValidator])]
          })
        );
      }
    });
  }

  get invoiceFormArray(): FormArray{
    return this.groupInvoiceForm.get("invoices") as FormArray;
  }

  checkTotalAmount(invoices: SchoolInvoicePost[]){
    let totalAmount = new Decimal(this.groupInvoiceForm.value.totalAmount);
    let invoiceTotalAmount = new Decimal(0);
    for(let invoice of invoices){
      invoiceTotalAmount = invoiceTotalAmount.plus(invoice.amount);
    }
    if(totalAmount.equals(invoiceTotalAmount)){
      return true
    }
    return false;
  }

  updateBookingList(){
    this.httpService.getBookingListItemsBySchoolId(this.groupInvoiceForm.value.school.id).subscribe(res => {
      this.bookings = res;
      this.invoiceFormArray.clear();
      for(let i = 0; i < 20; i++){
        this.invoiceFormArray.push(
          this.builder.group({
            booking: [null, Validators.required],
            amount: [null, Validators.compose([DecimalValidator, NumberValidator])]
          })
        );
      }
    });
  }

  uploadInvoices(){
    this.checkGroupFormValidity();
    let currency = this.groupInvoiceForm.value.currency;
    let date = moment(this.groupInvoiceForm.value.date).utc(true);
    let dueDate = moment(this.groupInvoiceForm.value.dueDate).utc(true);
    let type = this.groupInvoiceForm.value.paymentType;
    let invoiceNumber = this.groupInvoiceForm.value.invoiceNumber;
    let comment = this.groupInvoiceForm.value.comment;
    let invoices = [];
    for(let invoiceForm of this.invoiceFormArray.controls){
      if(invoiceForm.value.booking && invoiceForm.valid){
        invoices.push(new SchoolInvoicePost(
          invoiceNumber,
          date,
          invoiceForm.value.amount,
          currency,
          type,
          comment,
          dueDate,
          invoiceForm.value.booking.id,
          false
        ));
      } else if(invoiceForm.value.booking && invoiceForm.invalid){
        this.toastService.addError("Error", "Something is wrong");
        throw new Error("error");
      }
    }
    if(this.checkTotalAmount(invoices)){
      this.uploadingInvoices = true;
      this.httpService.postSchoolInvoices(invoices).subscribe(() =>{
        this.uploadingInvoices = false;
        this.toastService.addSuccess("Success", "Invoices uploaded");
        this.invoiceFormArray.clear();
      }, error => {
        this.uploadingInvoices = false;
        this.toastService.addError("Error", error.error.message);
      });
    } else {
      this.toastService.addError("Warning", "Sum of invoices is different than total amount encoded. Please verify");
    }
  }

  checkGroupFormValidity(){
    if(this.groupInvoiceForm.value.school && this.groupInvoiceForm.value.date && this.groupInvoiceForm.value.dueDate && this.groupInvoiceForm.value.invoiceNumber){
      return true;
    } else {
      this.toastService.addError("Error", "This group form is invalid. Please check the input value");
      throw new Error("groupInvoiceForm is Invalid");
    }
  }

}
